// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1ke4U","notes":"Notes_notes__11vOM","note":"Notes_note__3Pb4D","markdown":"Notes_markdown__236g5"};